module.exports = __webpack_public_path__ + "static/img/yanghua_3.40300349.png";